var SENTRY_RELEASE;SENTRY_RELEASE={name: "MarketPryce", version: "0.1.2"};